/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerStatisticsV2 = {
    properties: {
        playerStatistics: {
            type: 'array',
            contains: {
                type: 'SinglePlayerStatistic',
            },
            isRequired: true,
        },
        statistic: {
            type: 'StatisticV2',
            isRequired: true,
        },
        warnings: {
            type: 'array',
            contains: {
                type: 'Translation',
            },
            isRequired: true,
        },
    },
} as const;
